export const sidebar = {
  width: 240,
  collapsedWidth: 56,
  footerHeight: 50,
}

export const sidebarTotalWidth = sidebar.width + sidebar.collapsedWidth
